import React from 'react'
import RichText from '/react4xp/components/RichText'

interface Link {
   label: string,
   url: string,
   hasIcon: boolean,
}

interface Section {
   title: string,
   text: string,
   links: Link[],
}

interface Props {
   title: string,
   intro: string,
   infoBoxText: string,
   columns: Section[][],
   headingLevel?: 1 | 2 | 3 | 4 | 5,
}

const formIcon = (
   <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M12 15H9V12L18 3L21 6L12 15Z" stroke="#335377" strokeWidth="1.8" strokeLinecap="round" />
      <path d="M15.75 5.25L18.75 8.25" stroke="#335377" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M20.25 11.25V20.25H3.75L3.75 3.75L12.75 3.75" stroke="#335377" strokeWidth="1.8" strokeLinecap="square" />
   </svg>
)

const arrow = (
   <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M3.75 12H19.5" stroke="#335377" strokeWidth="2" strokeLinecap="square" strokeLinejoin="round" />
      <path d="M13.5 5.25L20.25 12L13.5 18.75" stroke="#335377" strokeWidth="2" strokeLinecap="square" />
   </svg>
)

export default function ContactUs(props: Props) {
   const { title, intro, infoBoxText, columns, headingLevel = 1 } = props

   // the part owns two levels: its own title and the column titles one below.
   // 1 is the default because this part carries the page title wherever it is
   // used today; a placement that is not the main content passes 2
   const Heading = `h${headingLevel}` as const
   const ColumnHeading = `h${headingLevel + 1}` as 'h2' | 'h3' | 'h4' | 'h5' | 'h6'

   return (
      <div className="contact-us">

         <div className="contact-us__header">
            <div className="grid-container">
               <div className="grid-row">
                  <div className="c-md-8">
                     <div className="header-wrapper">
                        {title && <Heading className='title font-title'>{title}</Heading>}
                        {intro && <div className='intro'><RichText content={intro} /></div>}
                     </div>
                  </div>
                  {infoBoxText && <div className="c-md-4">
                     <div className="contact-us__info-box">
                        <div className="info-box-wrapper">
                           <RichText content={infoBoxText} />
                        </div>
                     </div>
                  </div>}
               </div>
            </div>
         </div>

         <div className="contact-us__content">
            <div className="grid-container">
               <div className="grid-row">
                  {columns.map((column, index) => {
                     return <div className='c-md-4 contact-us__column' key={index}>
                        {column.map((section, sectionIndex) => {
                           return <div className="contact-us__section" key={sectionIndex}>
                              {section.title && <ColumnHeading className='title font-title'>{section.title}</ColumnHeading>}
                              {section.text && <div className='text'><RichText content={section.text} /></div>}
                              {section.links.map((link, linkIndex) => {
                                 return <a className='link' href={link.url} key={linkIndex}>
                                    <span className='link-content'>
                                       {link.hasIcon && <span className='icon'>{formIcon}</span>}
                                       {link.label}
                                    </span>
                                    <span className='arrow'>{arrow}</span>
                                 </a>
                              })}
                           </div>
                        })}
                     </div>
                  })}
               </div>
            </div>
         </div>
      </div>
   )
}
